<div
  class="atn-ds-table-column-headers"
  cdkDropList
  cdkDropListLockAxis="x"
  [cdkDropListSortingDisabled]="true"
>
  @if (store.showRowSelectSg()) {
    <div
      class="atn-ds-table-column-headers__cell atn-ds-table-column-headers__cell--select"
    >
      <atn-ds-checkbox
        [selected]="store.allRowsSelectedSg()"
        [someSelected]="store.someRowsSelectedSg()"
        (selectedChange)="onAllSelectChangeHandler()"
      />
    </div>
  }

  @for (attribute of store.visibleAttributesSg(); track $index) {
    @let columnWidth = store.getColumnWidthSg(attribute.id)();
    @let columnConfig = store.getColumnConfigSg(attribute.id)();

    <div
      class="atn-ds-table-column-headers__cell"
      [style.flex]="!columnWidth ? columnConfig.width.flex : undefined"
      [style.width.%]="!columnWidth ? columnConfig.width.percent : undefined"
      [style.text-align]="columnConfig.align"
      [style.width.px]="columnWidth ?? columnConfig.width.px"
      [ngStyle]="columnConfig.css"
      [atnDsMeasuredElement]="attribute"
    >
      <div
        class="atn-ds-table-column-headers__cell-content"
        [class.atn-ds-table-column-headers__cell-content--wrapped]="
          store.isCellContentWrappedSg()
        "
      >
        <span
          [class.atn-ds-table-column-headers__cell--sortable]="
            columnConfig.isSortable
          "
          (click)="columnConfig.isSortable && columnNameClickHandler(attribute)"
        >
          {{ attribute.name }}
        </span>
        @if (sortByIdSg() === attribute.id) {
          @if (isDescSortSg()) {
            <i class="fa fa-arrow-down"> </i>
          } @else {
            <i class="fa fa-arrow-up"> </i>
          }
        }
      </div>
      <div
        class="atn-ds-table-column-headers__cell-draggable"
        cdkDrag
        (cdkDragDropped)="columnResizeDroppedHandler($event, attribute)"
        (dblclick)="columnDblClickHandler(attribute)"
      >
        <div class="atn-ds-table-column-headers__cell-border"></div>
      </div>
    </div>
  }

  @if (store.hasIconsSg()) {
    <div
      class="atn-ds-table-column-headers__cell"
      [style.width.px]="store.iconsMaxWidthSg()"
    >
      <div
        class="atn-ds-table-column-headers__cell-content"
        [class.atn-ds-table-column-headers__cell-content--wrapped]="
          store.isCellContentWrappedSg()
        "
      ></div>
    </div>
  }
</div>
